import { render } from "./AddButton.vue?vue&type=template&id=5c409090&scoped=true"
const script = {}

import "./AddButton.vue?vue&type=style&index=0&id=5c409090&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c409090"]])

export default __exports__